import { Icon, IconButton } from '@material-ui/core';
import { refundBooking } from 'actions/booking';
import { showAlert } from 'actions/client';
import ConfirmationDialog from 'components/Utility/Dialogs/ConfirmationDialog';
import SearchBar from 'material-ui-search-bar';
import moment from 'moment';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { connect } from 'react-redux';
import {
  accentForCurrency,
  multiplyValueForCurrency,
} from 'utils/currency/currency-utils';
import ArrowRight from 'utils/images/arrow-right.svg';
import SearchClearIcon from 'utils/images/search-clear.svg';
import SearchIcon from 'utils/images/search.svg';
import {
  fetchAllCompletedBookings,
  fetchCompletedBookings,
} from '../../../../actions/booking';
import { fetchMenuList } from '../../../../actions/menus';
import { buildCategoryMap } from '../../../../utils/client/categoryMap';
import { exportToExcel } from '../../../../utils/client/excelExport';
import { SendBookingReminderAPIRequest } from '../../../../utils/constants/network';
import { callAPI } from '../../../../utils/network';
import FormSubmitButton from '../../../FormElements/FormSubmitButton';
import DateSelectorPill from '../shared/DateSelectorPill';
import './index.scss';

class CompletedBookingsPanel extends React.Component {
  state = {
    searchTerm: '',
    isSearching: false,
    bookingToRefund: null,
    bookingToReconfirm: null,
    showRefundConfirmation: false,
    showResendConfirmation: false,
    isResendingConfirmation: false,
    isRefunding: false,
    page: 0,
    fromMmt: moment().subtract(1, 'weeks').startOf('day'),
    toMmt: moment().subtract(1, 'second').add(1, 'hour').startOf('hour'),
    showExportMenu: false,
    fetchingAllForExport: false,
  };

  // Lifecycle

  componentWillUpdate(nextProps, nextState) {
    if (!nextProps.refundingBooking && this.props.refundingBooking) {
      this.setState({ isRefunding: false, bookingToRefund: null });

      if (nextProps.bookingRefunded && !this.props.bookingRefunded) {
        this.fetchCompletedBookings(this.state.page);
        this.showBookingRefunded();
      } else {
        this.showBookingRefundedError();
      }
    }
  }

  componentDidMount() {
    const { page } = this.state;
    this.fetchCompletedBookings(page);
    if (!this.props.menuList || this.props.menuList.length === 0) {
      this.props.fetchMenuList();
    }
  }

  updateFrom(component, value) {
    const newMmt = this.modifyMmt(this.state.fromMmt, value, component);
    this.setState({ fromMmt: newMmt, page: 0 }, () => {
      this.fetchCompletedBookings(0);
    });
  }

  updateTo(component, value) {
    const newMmt = this.modifyMmt(this.state.toMmt, value, component);
    this.setState({ toMmt: newMmt, page: 0 }, () => {
      this.fetchCompletedBookings(0);
    });
  }

  modifyMmt(originalMmt, newMmt, component) {
    let mmt = originalMmt.clone();

    if (component === 'time') {
      mmt = mmt.set({
        hour: newMmt.get('hour'),
        minute: newMmt.get('minute'),
        second: newMmt.get('second'),
      });
    } else {
      let newerMmt = newMmt.clone();
      newerMmt = newerMmt.set({
        hour: mmt.get('hour'),
        minute: mmt.get('minute'),
        second: mmt.get('second'),
      });

      return newerMmt;
    }

    return mmt;
  }

  fetchCompletedBookings(page) {
    const { searchTerm, fromMmt, toMmt } = this.state;
    this.props.fetchCompletedBookings(
      searchTerm,
      page,
      fromMmt.toISOString(),
      toMmt.toISOString()
    );
  }

  render() {
    const {
      searchTerm,
      showRefundConfirmation,
      showResendConfirmation,
      bookingToReconfirm,
      bookingToRefund,
      page,
      fromMmt,
      toMmt,
    } = this.state;
    const {
      completedBookings,
      fetchingCompletedBookings,
      refundBooking,
      venue,
      showAlert,
    } = this.props;

    return (
      <React.Fragment>
        <div className="panel__content">
          <div className="top__bar">
            <h2 className="panel__title">Completed Orders</h2>
            <SearchBar
              closeIcon={<img alt="" src={SearchClearIcon} />}
              searchIcon={
                <img
                  alt=""
                  style={{ color: 'rgba(0,0,0,1)' }}
                  src={SearchIcon}
                />
              }
              className="bookings__search__bar"
              placeholder="Search orders"
              value={searchTerm}
              onChange={searchValue => this.onSearchRequest(searchValue)}
              onRequestSearch={() =>
                this.onSearchRequest(this.state.searchTerm)
              }
              onCancelSearch={() => this.onSearchRequest('')}
            />
          </div>

          <div
            style={{
              display: 'flex',
              gap: '20px',
              alignItems: 'center',
              marginBottom: '20px',
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span style={{ fontSize: '12px', color: '#999' }}>From</span>
              <DateSelectorPill
                type="date"
                value={fromMmt}
                onChange={newVal => this.updateFrom('date', newVal)}
              >
                {fromMmt.format('DD/MM/YYYY')}
              </DateSelectorPill>
              <DateSelectorPill
                type="time"
                value={fromMmt}
                onChange={newVal => this.updateFrom('time', newVal)}
              >
                {fromMmt.format('HH:mm')}
              </DateSelectorPill>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span style={{ fontSize: '12px', color: '#999' }}>To</span>
              <DateSelectorPill
                type="date"
                value={toMmt}
                onChange={newVal => this.updateTo('date', newVal)}
              >
                {toMmt.format('DD/MM/YYYY')}
              </DateSelectorPill>
              <DateSelectorPill
                type="time"
                value={toMmt}
                onChange={newVal => this.updateTo('time', newVal)}
              >
                {toMmt.format('HH:mm')}
              </DateSelectorPill>
            </div>

            <div style={{ marginLeft: 'auto', position: 'relative' }}>
              <FormSubmitButton
                onClick={() =>
                  !this.state.fetchingAllForExport &&
                  this.setState(s => ({ showExportMenu: !s.showExportMenu }))
                }
                disabled={this.state.fetchingAllForExport}
                loading={this.state.fetchingAllForExport}
                className="fatsoma__cta"
                style={{ height: 32, marginTop: 4 }}
              >
                {this.state.fetchingAllForExport ? (
                  'Fetching...'
                ) : (
                  <span>
                    Export Excel{' '}
                    <Icon
                      style={{
                        fontSize: 16,
                        verticalAlign: 'middle',
                        marginLeft: 4,
                      }}
                    >
                      {this.state.showExportMenu
                        ? 'expand_less'
                        : 'expand_more'}
                    </Icon>
                  </span>
                )}
              </FormSubmitButton>
              {this.state.showExportMenu && (
                <div>
                  <div
                    style={{ position: 'fixed', inset: 0, zIndex: 99 }}
                    onClick={() => this.setState({ showExportMenu: false })}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 40,
                      zIndex: 100,
                      background: '#fff',
                      border: '1px solid #dedede',
                      borderRadius: 4,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                      minWidth: 180,
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{ padding: '10px 16px', cursor: 'pointer' }}
                      onMouseEnter={e =>
                        (e.currentTarget.style.background = '#f5f5f5')
                      }
                      onMouseLeave={e =>
                        (e.currentTarget.style.background = '#fff')
                      }
                      onClick={() => {
                        this.setState({ showExportMenu: false });
                        this.exportCompletedBookingsToExcel();
                      }}
                    >
                      Export page
                    </div>
                    <div
                      style={{
                        padding: '10px 16px',
                        cursor: this.state.fetchingAllForExport
                          ? 'not-allowed'
                          : 'pointer',
                        borderTop: '1px solid #f0f0f0',
                        color: this.state.fetchingAllForExport ? '#999' : '',
                      }}
                      onMouseEnter={e => {
                        if (!this.state.fetchingAllForExport)
                          e.currentTarget.style.background = '#f5f5f5';
                      }}
                      onMouseLeave={e =>
                        (e.currentTarget.style.background = '#fff')
                      }
                      onClick={() => {
                        if (this.state.fetchingAllForExport) return;
                        this.setState({ showExportMenu: false });
                        this.exportAllToExcel();
                      }}
                    >
                      {this.state.fetchingAllForExport
                        ? 'Fetching...'
                        : 'Export all records'}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="table__container">
            <table className="fold-table">
              <thead>
                <tr className="fold-table__header-row">
                  <th style={{ minWidth: 120 }}>Customer Name</th>

                  <th style={{ minWidth: 80 }}>Date</th>
                  <th style={{ minWidth: 50 }}>Time</th>
                  <th style={{ minWidth: 100 }}>Phone</th>
                  <th style={{ minWidth: 120 }}>Email</th>
                  {venue.tips_enabled && <th style={{ minWidth: 60 }}>Tips</th>}
                  <th style={{ minWidth: 60 }}>Total</th>
                  {/* <th style={{ minWidth: 60 }}>Profit</th> */}

                  <th style={{ minWidth: 70 }}>Type</th>
                  <th style={{ minWidth: 100 }}>Status</th>
                  <th style={{ minWidth: 30 }}></th>
                  <th className="refund__table__header"></th>
                </tr>
              </thead>
              <tbody>
                {completedBookings.map(booking => {
                  const bookingTime = moment(booking.paid_at);
                  const refundTime = moment(booking.refunded_at);
                  const bookingType = booking.live_collection
                    ? 'Collection'
                    : `Table (#${booking.table || 'N/A'})`;

                  const dateFormatted = bookingTime.format('DD/MM/YYYY');
                  const timeFormatted = bookingTime.format('HH:mm');

                  const isRefunded = booking.refunded > 0;
                  const bookingStatus = isRefunded
                    ? `Refunded ${accentForCurrency(venue.currency)}${(
                        booking.refunded /
                        multiplyValueForCurrency(venue.currency)
                      ).toFixed(2)} (${refundTime.format(
                        'DD/MM/YYYY'
                      )} at ${refundTime.format('HH:mm')})`
                    : 'Completed';
                  let orderItemsIndex = 0;

                  const isResendingConfirmation =
                    this.state.isResendingConfirmation &&
                    this.state.bookingToReconfirm === booking;
                  const isRefunding =
                    this.state.isRefunding &&
                    this.state.bookingToRefund === booking;

                  return (
                    <React.Fragment key={booking.id + dateFormatted}>
                      <tr
                        className="view"
                        onClick={event => this.handleRowClick(event)}
                      >
                        <td className="td__booking__name">
                          <span className="td__booking__arrow">
                            <img alt="order arrow" src={ArrowRight} />
                          </span>
                          {booking.name || ''}
                        </td>

                        <td style={{ paddingLeft: 60 }}>{dateFormatted}</td>
                        <td style={{ paddingLeft: 30 }}>{timeFormatted}</td>
                        <td
                          className="td__booking__name"
                          style={{ paddingLeft: 30 }}
                        >
                          <span className="td__booking__arrow"></span>
                          {booking.phone}
                        </td>
                        <td className="td__booking__name">
                          <span className="td__booking__arrow"></span>
                          {booking.email || ''}
                        </td>
                        {venue.tips_enabled && (
                          <td>{`${accentForCurrency(venue.currency)}${(
                            booking.tip_amount /
                            multiplyValueForCurrency(venue.currency)
                          ).toFixed(2)}`}</td>
                        )}
                        <td>{`${accentForCurrency(venue.currency)}${(
                          booking.total /
                          multiplyValueForCurrency(venue.currency)
                        ).toFixed(2)}`}</td>
                        {/* <td>
                          {booking.profit !== null &&
                          booking.profit !== undefined
                            ? `${accentForCurrency(venue.currency)}${(
                                booking.profit /
                                multiplyValueForCurrency(venue.currency)
                              ).toFixed(2)}`
                            : '-'}
                        </td> */}
                        <td>{bookingType}</td>
                        <td>{bookingStatus}</td>

                        <td>
                          {!isRefunded && (
                            <IconButton
                              color="primary"
                              disabled={
                                this.state.bookingToReconfirm === booking
                              }
                              onClick={e => {
                                e.stopPropagation();
                                this.triggerReconfirmation(booking);
                              }}
                              className="resend__confirmation__cta"
                            >
                              <Icon
                                className={
                                  isResendingConfirmation ? 'animate__spin' : ''
                                }
                              >
                                {isResendingConfirmation ? 'loop' : 'email'}
                              </Icon>
                            </IconButton>
                          )}
                        </td>
                        <td>
                          {!isRefunded && (
                            <FormSubmitButton
                              disabled={this.state.bookingToRefund === booking}
                              loaderWidth={60}
                              className="completed__orders refund__cta"
                              loading={isRefunding}
                              onClick={e => {
                                e.stopPropagation();
                                this.triggerRefund(booking);
                              }}
                            >
                              Refund
                            </FormSubmitButton>
                          )}
                        </td>
                      </tr>
                      <tr className="fold">
                        <td colSpan="12">
                          <div className="fold-content">
                            <div className="order__details__header">
                              <strong>Order Details</strong>
                            </div>
                            {booking.order_items.map(product => {
                              const children = product.children || [];
                              orderItemsIndex += 1;
                              const vatServiceLabel =
                                booking.service_type === 'table'
                                  ? 'Eat-in'
                                  : booking.service_type === 'dropoff'
                                  ? 'Dropoff'
                                  : 'Takeaway';
                              const pricePerUnit =
                                product.productPrice /
                                multiplyValueForCurrency(venue.currency);
                              const subtotal =
                                product.totalPrice /
                                multiplyValueForCurrency(venue.currency);

                              return (
                                <React.Fragment
                                  key={
                                    booking.id +
                                    (product.id || product.name) +
                                    orderItemsIndex
                                  }
                                >
                                  <div>
                                    <span className="order__container__item__text">
                                      {product.quantity} x
                                    </span>{' '}
                                    <span className="order__container__item__name">
                                      {product.name}
                                    </span>{' '}
                                    <span className="order__container__item__price">
                                      @ {accentForCurrency(venue.currency)}
                                      {pricePerUnit.toFixed(2)}
                                    </span>{' '}
                                    {venue.enable_vat &&
                                      product.vatRate > 0 && (
                                        <span className="order__container__item__vat">
                                          {' '}
                                          + (
                                          {(product.vatRate * 100).toFixed(
                                            0
                                          )}% {vatServiceLabel} VAT)
                                        </span>
                                      )}
                                    <span className="order__container__item__subtotal">
                                      = {accentForCurrency(venue.currency)}
                                      {subtotal.toFixed(2)}
                                    </span>
                                  </div>
                                  {children.map(variant => (
                                    <div
                                      key={
                                        booking.id +
                                        orderItemsIndex +
                                        product.id +
                                        (variant.id || variant.name)
                                      }
                                      className="order__container__item__variant"
                                    >
                                      +{' '}
                                      <span className="order__container__item__text">
                                        +{' '}
                                        {variant.quantity > 1
                                          ? variant.quantity
                                          : ''}{' '}
                                        {variant.name}
                                      </span>
                                      {venue.enable_vat &&
                                        variant.vatRate > 0 && (
                                          <span className="order__container__item__vat">
                                            {' '}
                                            ({vatServiceLabel} VAT{' '}
                                            {(variant.vatRate * 100).toFixed(0)}
                                            %)
                                          </span>
                                        )}
                                    </div>
                                  ))}
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
              <tfoot>
                <tr />
              </tfoot>
            </table>

            <div className="pagination__container">
              <div
                style={{ cursor: page === 0 ? 'auto' : 'pointer' }}
                onClick={() => this.changePage(page - 1)}
                className="arrow__container"
              >
                <img
                  style={{ opacity: page === 0 ? 0.2 : 1 }}
                  alt="paginate left"
                  className="arrow__left"
                  src={ArrowRight}
                ></img>
              </div>
              <div className="page__number">Page {page + 1}</div>
              <div
                style={{
                  cursor: completedBookings.length < 20 ? 'auto' : 'pointer',
                }}
                onClick={() => this.changePage(page + 1)}
                className="arrow__container"
              >
                <img
                  style={{ opacity: completedBookings.length < 20 ? 0.2 : 1 }}
                  alt="paginate right"
                  src={ArrowRight}
                ></img>
              </div>
            </div>
          </div>
        </div>

        <ConfirmationDialog
          open={showRefundConfirmation}
          confirmationTitle="Refund Booking"
          onClose={() => this.hideRefundConfirmation()}
          showInput={true}
          inputLabel={`Refund Amount (${accentForCurrency(venue.currency)})`}
          confirmationDescription="You are about to refund this booking. How much would you like to refund?"
          inputPlaceholder="e.g 1.99"
          inputDefaultValue={
            bookingToRefund
              ? (
                  (bookingToRefund.total - bookingToRefund.fee_paid) /
                  multiplyValueForCurrency(venue.currency)
                ).toFixed(2)
              : ''
          }
          onConfirm={refundAmountString => {
            const amountNumber = parseFloat(refundAmountString);

            if (isNaN(amountNumber)) {
              showAlert("That's not a valid amount. Please try again.");
              return;
            }

            if (
              amountNumber * multiplyValueForCurrency(venue.currency) >
                bookingToRefund.total - bookingToRefund.fee_paid ||
              amountNumber === 0
            ) {
              showAlert(
                "You didn't enter a valid refund amount. It must greater than 0 and less than the total."
              );
              return;
            }

            const rValue = Math.round(
              amountNumber * multiplyValueForCurrency(venue.currency)
            );
            this.setState({ isRefunding: true, showRefundConfirmation: false });
            refundBooking(bookingToRefund.id, rValue);
          }}
        />

        <ConfirmationDialog
          open={showResendConfirmation}
          confirmationTitle="Resend Confirmation Email"
          onClose={() => this.hideResendConfirmation()}
          showInput={true}
          wideInput
          inputLabel={`Email Address`}
          confirmationDescription="Send another order confirmation email to this customer. Just confirm the customer’s email below, and then press the Resend button."
          inputPlaceholder="e.g susie@mail.com"
          inputDefaultValue={bookingToReconfirm ? bookingToReconfirm.email : ''}
          positiveActionText="Resend"
          negativeActionText="Cancel"
          onConfirm={emailAddress => {
            this.resendConfirmation(bookingToReconfirm, emailAddress);
            this.setState({ showResendConfirmation: false });
          }}
        />

        <Loader fullPage loading={fetchingCompletedBookings} />
      </React.Fragment>
    );
  }

  // Utils

  resendConfirmation = async (booking, emailAddress) => {
    this.setState({ isResendingConfirmation: true });
    try {
      const apiRequest = SendBookingReminderAPIRequest({
        booking: booking.id,
        email: emailAddress,
      });
      await callAPI(apiRequest);

      this.props.showAlert(
        'Confirmation Resent',
        "We've re-sent the order confirmation to this customer."
      );
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not resend this order confirmation.'
      );
    } finally {
      this.hideResendConfirmation();
    }
  };

  handleRowClick = event => {
    const nameEl = event.currentTarget.querySelector('.td__booking__name');

    nameEl.classList.toggle('bold__header');
    event.currentTarget.classList.toggle('open');
    event.currentTarget.nextSibling.classList.toggle('open');
  };

  changePage = newPage => {
    if (newPage < 0) {
      return;
    }

    if (this.props.completedBookings.length < 20 && newPage > this.state.page) {
      return;
    }

    this.setState({ page: newPage });

    this.fetchCompletedBookings(newPage);
  };

  onSearchRequest = query => {
    const isSearching = query !== '';
    this.setState(
      { searchTerm: query, isSearching: isSearching, page: 0 },
      () => {
        this.fetchCompletedBookings(0);
      }
    );
  };

  exportCompletedBookingsToExcel = () => {
    const { completedBookings, venue, menuList, showAlert } = this.props;

    if (!completedBookings || completedBookings.length === 0) {
      showAlert('No Data', 'No orders to export.');
      return;
    }

    const categoryMap = buildCategoryMap(menuList);
    exportToExcel(
      completedBookings,
      venue,
      multiplyValueForCurrency,
      categoryMap
    );
  };

  exportAllToExcel = async () => {
    const { venue, menuList, showAlert, fetchAllCompletedBookings } =
      this.props;
    const { searchTerm, fromMmt, toMmt } = this.state;

    this.setState({ fetchingAllForExport: true });
    try {
      const allBookings = await fetchAllCompletedBookings(
        searchTerm,
        fromMmt.toISOString(),
        toMmt.toISOString()
      );

      if (!allBookings || allBookings.length === 0) {
        showAlert('No Data', 'No orders to export.');
        return;
      }

      const categoryMap = buildCategoryMap(menuList);
      exportToExcel(allBookings, venue, multiplyValueForCurrency, categoryMap);
    } catch (e) {
      console.error(e);
      showAlert(
        'Export Failed',
        'Could not export all records. Please try again.'
      );
    } finally {
      this.setState({ fetchingAllForExport: false });
    }
  };

  triggerRefund = booking => {
    this.setState({
      bookingToRefund: booking,
      showRefundConfirmation: true,
    });
  };

  triggerReconfirmation = booking => {
    this.setState({
      bookingToReconfirm: booking,
      showResendConfirmation: true,
    });
  };

  hideRefundConfirmation = () => {
    this.setState({
      bookingToRefund: null,
      showRefundConfirmation: false,
    });
  };

  hideResendConfirmation = () => {
    this.setState({
      showResendConfirmation: false,
      bookingToReconfirm: null,
      isResendingConfirmation: false,
    });
  };

  showBookingRefunded = () => {
    this.props.showAlert('Booking Refunded', 'Successfully refunded booking.');
  };

  showBookingRefundedError = () => {
    this.props.showAlert(
      'Could not refund booking',
      'Failed to refund booking. Please try again later.'
    );
  };
}

const mapStateToProps = state => ({
  venue: state.venue,
  menuList: state.menu.menuList,
  completedBookings: state.booking.completedBookings,
  fetchingCompletedBookings: state.booking.fetchingCompletedBookings,
  completedBookingsFetched: state.booking.compeltedBookingsFetched,
  bookingRefunded: state.booking.bookingRefunded,
  refundingBooking: state.booking.refundingBooking,
});

const mapDispatchToProps = dispatch => ({
  showAlert: (title, desc) => dispatch(showAlert(title, desc)),
  fetchCompletedBookings: (query, page, from, to) =>
    dispatch(fetchCompletedBookings(query, page, from, to)),
  fetchAllCompletedBookings: (query, from, to) =>
    dispatch(fetchAllCompletedBookings(query, from, to)),
  fetchMenuList: () => dispatch(fetchMenuList()),
  refundBooking: (id, amountPence) => dispatch(refundBooking(id, amountPence)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompletedBookingsPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/CompletedBookings/index.jsx